import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import SearchBar from "./searchbar";
import PersonIcon from "@material-ui/icons/Person";
import Tooltip from "@material-ui/core/Tooltip";
import EventIcon from "@material-ui/icons/Event";
// import IconButton from "@material-ui/core/IconButton";
import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import NoRecords from "./../../Global/NoRecords";
import Spinner from "./../../Global/Spinner2";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation } from "react-i18next";
import moment from "moment";
import _ from "lodash";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Colors from "./../../Global/colors";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  container: {
    maxHeight: "55vh",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export default function ScheduleTable({
  schedule,
  setSchedule,
  scheduleLoader,
  searchText,
  fetchMissed,
}) {
  const {t} = useTranslation();
  let history = useHistory();
  let company = useSelector((state) => state.companyReducer.company);
  let language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  const theme = useTheme();
  const [pagination, setPagination] = useState({
    indexNo: 5,
    selected: 0,
  });
  const [users, setUsers] = useState([]);
  const [currentInspection, setCurrentInspection] = useState("");
  let localstorage = localStorage.getItem("UserData");
  var userData = JSON.parse(localstorage);
  const [permissions_obj, setPermissionObj] = useState({});
  const [note,setNote] = useState("");
  const [loader, setLoader] = useState(false);
  const [currentObj,setCurrentObj] = useState({
    schedule_id: "",
    missed_date: "",
  });
  const [open, setOpen] = React.useState(false);
  const [packageDetails, setPackageDetails] = React.useState(null);

  const groups1 = _.groupBy(schedule, "filter_date");


  React.useEffect(
    () => {
      getPermissions();
      fetchUsers();
      getPackageDetails();
    },
    [company?.id]
  );


  console.log("Note",note);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentObj({schedule_id: "",missed_date:""});
  };


  const rescheduleInspection = () => {
    console.log("currentObj",currentObj);
    if(note == ""){
      swal(t("Please enter note"));
      return;
    }
    const localstorage = localStorage.getItem("UserData");
    var userData = JSON.parse(localstorage);

    fetch(GlobalApi + "/Schedule/reschedule", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + userData.token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        ...currentObj,
        note,
        
      }),
    })
      .then((res) => res.json())
      .then(async (resJson) => {
        console.log("RESPONSE OF RESCHEDULE API", resJson);
        if(resJson.msg == 'success'){
          swal(t("Inspection Reschedued Successfully"));
          setNote("");
          handleClose();
          fetchMissed(true)
        }

        
      })
      .catch((error) => console.log("error", error));

  }


  async function createInspection({ id, schedule_id,created_at }) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let inspection_obj = {
      schedule_id,
      template_id: id,
      user_id: data.user_id,
      company_id: company?.id,
      created_by: data.user_id,
      missed_date:created_at,
    };

    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

    if (reqJson.package.inspection_request_status === "Request is Valid") {
      fetch(GlobalApi + "/Inspection/create_inspection", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(inspection_obj),
      })
        .then((response) => response.json())
        .then(async (res1) => {
          console.log(res1);
          fetch(GlobalApi + "/InspectionShare/create_inspection_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              inspection_id: res1.data.id,
              user_id: data.user_id,
              created_by: data.user_id,
              role: "Owner",
              isEditor: true,
              isOwner: true,
            }),
          })
            .then((response) => response.json())
            .then(async (res) => {
              console.log(res);
              setLoader(false);
              history.push("/inspection-edit/" + res1.data.id + "/edit");
            });
        });
    } else {
      swal(t("Warning"), reqJson.package.inspection_request_status, "warning");
      setLoader(false);
    }
  }

  function handleStart(schedule_id, template_id,created_at) {
    setLoader(true);
    console.log(schedule_id, template_id);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      schedule_id,
      template_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/TemplateInspection/get_template_for_inspection?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response>>>", response);
        if (response.status === "Success") {
          if (response.data) {
            createInspection({...response.data,created_at});

            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            handleStart(schedule_id, template_id);
          }
        }
      })
      .catch((error) => {console.log(error.message); setLoader(false);});
    console.log("op");
  }



  const getPermissions = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();

            if (status) {
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("Error", error.message);
        });
    }
  };

  async function getPackageDetails(company) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

    if (
      reqJson?.package?.license?.status === "expired" ||
      reqJson?.package?.license?.status === "deactive"
    ) {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  const fetchUsers = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status === "Success") {
          setUsers(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };



  function X(userData, permissions_obj, open, handleOpen, handleClose) {
    return Object.keys(groups1).length !== 0 ? (
      Object.keys(groups1).map((key, index) => {
        return groups1[key]
          ?.filter((v) =>
            v?.title?.toLowerCase().includes(searchText?.toLowerCase())
          )
          .sort(
            (a, b) =>
              new Date(b.filter_date).getTime() -
              new Date(a.filter_date).getTime()
          )
          .map((response, ini) => {
            console.log(":::::::::::::::::::::::::::::::::::::", response);
            return <TableRow key={response.id + ini + index}>
                <TableCell style={{ padding: 8, textTransform: "capitalize",textAlign:language == "ar" ? "right" : "left" }}>
                  {<Tooltip title={response.title ? response.title : ""}>
                      <p style={{ margin: 0 }}>
                        {response.title.slice(0, 30) +
                          (response.title.length > 30 ? "..." : "")}
                      </p>
                    </Tooltip>}
                </TableCell>

                <TableCell style={{ padding: 8, textTransform: "capitalize", borderLeft: "1px solid #dadada", borderRight: "1px solid #dadada",textAlign:language == "ar" ? "right" : "left", }}>
                  {<Tooltip title={response?.Template?.title ? response?.Template?.title : ""}>
                      <p style={{ margin: 0 }}>
                        {response?.Template?.title.slice(0, 20) +
                          (response?.Template?.title.length > 20
                            ? "..."
                            : "")}
                      </p>
                    </Tooltip>}
                </TableCell>

                <TableCell style={{ padding: 8, textTransform: "capitalize",textAlign:language == "ar" ? "right" : "left", }}>
                  {<Tooltip title={response?.site_title ? response?.site_title : ""}>
                      <p style={{ margin: 0 }}>
                        {response?.site_title.slice(0, 15) +
                          (response?.site_title.length > 15
                            ? "..."
                            : "")}
                      </p>
                    </Tooltip>}
                </TableCell>
                {/* <TableCell>{response?.TemplateInspection?.title}</TableCell> */}
                <TableCell style={{ padding: "5px 8px ",textAlign:language == "ar" ? "right" : "left", textTransform: "capitalize", borderLeft: "1px solid #dadada", borderRight: "1px solid #dadada" }}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {response.ScheduleAssignees.map((v, i) => {
                      const Listing = _.filter(users, {
                        id: v.user_id,
                      });
                      if (i <= 2) {
                        return <Tooltip title={`${Listing[0] ? Listing[0].first_name : ""} ${Listing[0] ? Listing[0].last_name : ""}`} aria-label="">
                            {Listing[0]?.avatar !== null ? <div style={{ width: 30, height: 30, borderRadius: "50px", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center", backgroundImage: `url(https://server.uraudits.com/view?Key=${Listing[0]?.avatar})`, backgroundSize: "cover" }} /> : <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                                <p style={{ margin: 0, fontWeight: "bold", fontSize: "10px" }}>
                                  {Listing[0] ? Listing[0].first_name
                                        .substring(0, 1)
                                        .toUpperCase()
                                        .concat(Listing[0] ? Listing[0].last_name
                                                .substring(0, 1)
                                                .toUpperCase() : "") : ""}
                                </p>
                              </div>}
                          </Tooltip>;
                      } else {
                        return <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                            <p style={{ margin: 0, fontWeight: "bold", fontSize: "10px" }}>
                              +{response.ScheduleAssignees.length - 3}
                            </p>
                          </div>;
                      }
                    })}
                  </div>
                </TableCell>
                <TableCell style={{ padding: 3,textAlign:language == "ar" ? "right" : "left",  borderRight: language == "ar" ? "none" : "1px solid #dadada",
                            borderLeft: language == "ar" ?  "1px solid #dadada" : "none",  }}>
                  <div>
                    <span>
                      {moment(response.filter_date).format(
                        "MM/DD/YY"
                      )}
                    </span>
                  </div>
                </TableCell>
                <TableCell style={{ padding: 3, textAlign: "center" }}>
                  <div>
                    {userData?.user_id === response.created_by || userData?.super_admin == true || permissions_obj["Admin"] == true ? <>
                        {(response?.RescheduleDocs?.length > 0 && response.missed) ? <Button size="small" className="startInspectionBtnSmall" style={{ backgroundColor: Colors.globalColor8 }} onClick={() => {
                              setCurrentInspection(response);
                              console.log(response.filter_date,"response.filter_date");
                              handleStart(response.id, response.template_id,response.filter_date);
                            }}>
                            {(loader === true && currentInspection.id == response.id && response.filter_date == currentInspection.filter_date )&& <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}
                            {t("Start")}
                          </Button> : <Button size="small" className="startInspectionBtnSmall" style={{ backgroundColor: Colors.globalColor8 }} onClick={() => {
                              handleOpen();
                              setCurrentObj({
                                schedule_id: response.id,
                                missed_date: response.filter_date,
                              });
                            }}>
                            {t("Reschedule")}
                          </Button>}{" "}
                      </> : <>
                        <Button size="small" className="startInspectionBtnSmall2" disabled style={{ backgroundColor: "grey" }}>
                          {t("Reschedule")}
                        </Button>
                      </>}
                  </div>
                </TableCell>
              </TableRow>;
          });
      })
    ) : (
      <TableRow style={{ border: "1px solid #dadada" }}>
        <TableCell colSpan={6}>
          <NoRecords />
        </TableCell>
      </TableRow>
    );
  }

  if (packageDetails !== null) {
    return (  
      <div style={{ padding: "10px" }}>
        <main>
          {scheduleLoader && (
            <div
              style={{
                height: "50vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner />
            </div>
          )}

          {!scheduleLoader && (
            <div style={{ overflow: "auto" }}>
              {window.innerWidth > 500 && (
                <TableContainer className={classes.container}>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    style={{
                      width: "100%",
                      borderLeft: "1px solid #dadada",
                      borderRight: "1px solid #dadada",
                    }}
                    className="scheduleTable"
                  >
                    <TableHead
                      style={{ backgroundColor: "#f2f2f2" }}
                      className=""
                    >
                      <TableRow>
                        <TableCell
                          style={{
                            padding: 8,
                            textAlign:language == "ar" ? "right" : "left",
                            borderTop: "1px solid #dadada",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Schedule")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: 8,
                            textAlign: language == "ar" ? "right" : "left",
                            borderTop: "1px solid #dadada",
                            borderLeft: "1px solid #dadada",
                            borderRight: "1px solid #dadada",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Template")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: 8,
                            textAlign: language == "ar" ? "right" : "left",
                            borderTop: "1px solid #dadada",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Site")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: 8,
                            textAlign: language == "ar" ? "right" : "left",
                            borderTop: "1px solid #dadada",
                            borderLeft: "1px solid #dadada",
                            borderRight: "1px solid #dadada",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Missed by")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: 8,
                            textAlign: language == "ar" ? "right" : "left",
                            borderTop: "1px solid #dadada",
                            borderRight: language == "ar" ? "none" : "1px solid #dadada",
                            borderLeft: language == "ar" ?  "1px solid #dadada" : "none",                           
                            
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Missed on")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: 8,
                            textAlign: language == "ar" ? "right" : "left",
                            borderTop: "1px solid #dadada",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Action")}
                          </p>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody className="table-schedule">
                      {X(
                        userData,
                        permissions_obj,
                        open,
                        handleOpen,
                        handleClose
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {window.innerWidth <= 500 && (
                <div
                  className={classes.container}
                  style={{ overflowY: "scroll", width: "100%", padding: "5px" }}
                >
                  {Object.keys(groups1).length !== 0 ? (
                    Object.keys(groups1).map((key, index) => {
                      return groups1[key]
                        ?.filter((v) =>
                          v?.title
                            ?.toLowerCase()
                            .includes(searchText?.toLowerCase())
                        )
                        .sort(
                          (a, b) =>
                            new Date(b.filter_date).getTime() -
                            new Date(a.filter_date).getTime()
                        )
                        .map((response, ini) => {
                          console.log(
                            ":::::::::::::::::::::::::::::::::::::",
                            response
                          );
                          return (
                            <div
                              className="hover shadow"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                border: "1px solid #dadada",
                                padding: "10px",
                                margin: "5px",
                                flexDirection: "row",
                                alignItems: "center",
                                textAlign: "left",
                                height: "220px",
                                borderRadius: "5px",
                                backgroundColor: "white",
                                overflow: "hidden",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  height: "100%",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <p
                                    style={{
                                      color: Colors.globalColor8,
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    Schedule
                                  </p>

                                  <p
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    {response.title.slice(0, 30) +
                                      (response.title.length > 30 ? "..." : "")}
                                  </p>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      color: Colors.globalColor8,
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    Template
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    {response?.Template?.title.slice(0, 20) +
                                      (response?.Template?.title.length > 20
                                        ? "..."
                                        : "")}
                                  </p>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      color: Colors.globalColor8,
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    Site{" "}
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    {response?.site_title.slice(0, 15) +
                                      (response?.site_title.length > 15
                                        ? "..."
                                        : "")}
                                  </p>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      color: Colors.globalColor8,
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      textAlign: "left",
                                      marginBottom: "0px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    Missed By{" "}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {response.ScheduleAssignees.map((v, i) => {
                                      const Listing = _.filter(users, {
                                        id: v.user_id,
                                      });
                                      if (i <= 2) {
                                        return (
                                          <Tooltip
                                            title={`${
                                              Listing[0]
                                                ? Listing[0].first_name
                                                : ""
                                            } ${
                                              Listing[0]
                                                ? Listing[0].last_name
                                                : ""
                                            }`}
                                            aria-label=""
                                          >
                                            {Listing[0]?.avatar !== null ? (
                                              <div
                                                style={{
                                                  width: 30,
                                                  height: 30,
                                                  borderRadius: "50px",
                                                  color: "#043077",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  margin: 1,
                                                  alignItems: "center",
                                                  backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                    Listing[0]?.avatar
                                                  })`,
                                                  backgroundSize: "cover",
                                                }}
                                              />
                                            ) : (
                                              <div
                                                style={{
                                                  width: 30,
                                                  height: 30,
                                                  borderRadius: "50px",
                                                  border: "1px solid #043077",
                                                  color: "#043077",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  margin: 1,
                                                  alignItems: "center",
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    fontWeight: "bold",
                                                    fontSize: "10px",
                                                  }}
                                                >
                                                  {Listing[0]
                                                    ? Listing[0].first_name
                                                        .substring(0, 1)
                                                        .toUpperCase()
                                                        .concat(
                                                          Listing[0]
                                                            ? Listing[0].last_name
                                                                .substring(0, 1)
                                                                .toUpperCase()
                                                            : ""
                                                        )
                                                    : ""}
                                                </p>
                                              </div>
                                            )}
                                          </Tooltip>
                                        );
                                      } else {
                                        return (
                                          <div
                                            style={{
                                              width: 30,
                                              height: 30,
                                              borderRadius: "50px",
                                              border: "1px solid #043077",
                                              color: "#043077",
                                              display: "flex",
                                              justifyContent: "center",
                                              margin: 1,
                                              alignItems: "center",
                                            }}
                                          >
                                            <p
                                              style={{
                                                margin: 0,
                                                fontWeight: "bold",
                                                fontSize: "10px",
                                              }}
                                            >
                                              +
                                              {response.ScheduleAssignees
                                                .length - 3}
                                            </p>
                                          </div>
                                        );
                                      }
                                    })}
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  height: "100%",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <Tooltip
                                    title={moment(response.filter_date).format(
                                      "MM/DD/YY"
                                    )}
                                  >
                                    <p style={{ margin: 0 }}>
                                      <EventIcon
                                        style={{ color: Colors.globalColor8 }}
                                      />
                                    </p>
                                  </Tooltip>
                                </div>

                                {/* {response.status == "active" && <div>
                                  <DoneAllIcon style={{ color: "green" }} />
                                </div>}

                              <div>
                                <img src={EditG} alt="edit" onClick={() => history.push("/schedule-edit/" + response.id)} />
                              </div> */}
                              </div>
                            </div>
                          );
                        });
                    })
                  ) : (
                    <TableRow style={{ border: "1px solid #dadada" }}>
                      <TableCell colSpan={5}>
                        <NoRecords />
                      </TableCell>
                    </TableRow>
                  )}
                </div>
              )}
            </div>
          )}
        </main>
        <Dialog open={open} onClose={handleClose} style={{boxShadow:'none'}} className="rescheduleBox" >
        <DialogTitle id="form-dialog-title">
        <p className="label2" style={{ marginBottom: 5, fontSize: 16, marginTop: 7, color: Colors.globalColor8, textTransform: "uppercase" }}>
            Reschedule Inspection
          </p>
        </DialogTitle>
        <DialogContent>

          <TextField autoFocus margin="dense" id="name" label="Note" style={{minWidth:'300px'}} placeholder="Add a Note" value={note}  onChange={(e)=>setNote(e.target.value)} fullWidth autoComplete="off" className={["customField", { className: classes.textBoxStyle }]} InputProps={{ className: classes.textBoxStyle }} />          
        
        </DialogContent>
        <DialogActions>
        <Button onClick={()=>rescheduleInspection()} className="addBtn"  color="primary">
              Reschedule
          </Button>
          <Button onClick={()=>handleClose()} className="cancelBtn" color="primary" style={{boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);"}}>
              Cancel
          </Button>
        </DialogActions>
      </Dialog>
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }
}
